export var UserAdminFlag;
(function (UserAdminFlag) {
    UserAdminFlag[UserAdminFlag["NONE"] = 0] = "NONE";
    UserAdminFlag[UserAdminFlag["BYPASS_VIDEO_AUTO_BLACKLIST"] = 1] = "BYPASS_VIDEO_AUTO_BLACKLIST";
})(UserAdminFlag || (UserAdminFlag = {}));
